// Original logic grid. Not affiliated with any published puzzle.

const TITLE = "The Quiet House";
const DEK = "Four people stayed after ten. One of them is guilty.";

const FIRST = [
  "Nell", "Ida", "Owen", "Ruth", "Paul", "Vera", "Hugh", "Joan",
  "Carl", "Mae", "Seth", "Nina", "Glen", "Rosa", "Ivan", "Beth",
  "Anne", "Luke", "Edie", "Mark", "Cora", "Neil", "June", "Fred",
];

const LAST = [
  "Hale", "Crowe", "Peck", "Lang", "Ortiz", "Walsh", "Byrne", "Frost",
  "Keene", "Marsh", "Doyle", "Quinn", "Berg", "Holt", "Shaw", "Moss",
  "Reid", "Cobb", "Nash", "Bell", "Grey", "Dunn", "Paige", "Lowe",
];

const ROOMS = [
  "Boathouse", "Map room", "Stillroom", "Gate lodge",
  "Drying loft", "Chart room", "Pump house", "Lamp room",
  "Linen room", "Signal box", "Potting shed", "Ticket hall",
];

const ITEMS = [
  "boat hook", "desk weight", "shears", "brass lamp",
  "hand bell", "press iron", "coal shovel", "ink roller",
  "mallet", "flask", "hand saw", "broom",
];

function mulberry32(seed) {
  let a = seed >>> 0;
  return function () {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function shuffle(rng, list) {
  const copy = list.slice();
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const swap = copy[i];
    copy[i] = copy[j];
    copy[j] = swap;
  }
  return copy;
}

function permutations(n) {
  const out = [];
  const used = [];
  const cur = [];
  for (let i = 0; i < n; i++) used.push(false);
  function walk() {
    if (cur.length === n) {
      out.push(cur.slice());
      return;
    }
    for (let i = 0; i < n; i++) {
      if (used[i]) continue;
      used[i] = true;
      cur.push(i);
      walk();
      cur.pop();
      used[i] = false;
    }
  }
  walk();
  return out;
}

const PERMS = permutations(4);

function allWorlds() {
  const worlds = [];
  for (let r = 0; r < PERMS.length; r++) {
    for (let m = 0; m < PERMS.length; m++) {
      for (let guilty = 0; guilty < 4; guilty++) {
        worlds.push({ rooms: PERMS[r], items: PERMS[m], guilty: guilty });
      }
    }
  }
  return worlds;
}

const WORLDS = allWorlds();

function holds(world, clue) {
  if (clue.type === "personRoom") return (world.rooms[clue.person] === clue.room) === clue.yes;
  if (clue.type === "personItem") return (world.items[clue.person] === clue.item) === clue.yes;
  if (clue.type === "roomItem") {
    let person = 0;
    while (world.rooms[person] !== clue.room) person++;
    return (world.items[person] === clue.item) === clue.yes;
  }
  if (clue.type === "guiltyPerson") return (world.guilty === clue.person) === clue.yes;
  if (clue.type === "guiltyRoom") return (world.rooms[world.guilty] === clue.room) === clue.yes;
  if (clue.type === "guiltyItem") return (world.items[world.guilty] === clue.item) === clue.yes;
  throw new Error("Unknown clue");
}

function survivors(clues) {
  const left = [];
  for (let i = 0; i < WORLDS.length; i++) {
    let ok = true;
    for (let c = 0; c < clues.length; c++) {
      if (!holds(WORLDS[i], clues[c])) {
        ok = false;
        break;
      }
    }
    if (ok) left.push(WORLDS[i]);
  }
  return left;
}

function sameWorld(a, b) {
  if (a.guilty !== b.guilty) return false;
  for (let i = 0; i < 4; i++) {
    if (a.rooms[i] !== b.rooms[i] || a.items[i] !== b.items[i]) return false;
  }
  return true;
}

function clueText(clue, people, rooms, items) {
  const person = people[clue.person] ? people[clue.person][0] + " " + people[clue.person][1] : "";
  const room = rooms[clue.room] || "";
  const item = items[clue.item] || "";
  if (clue.type === "personRoom") {
    return clue.yes ? person + " was in the " + room.toLowerCase() + "." : person + " was not in the " + room.toLowerCase() + ".";
  }
  if (clue.type === "personItem") {
    return clue.yes ? person + " had the " + item + "." : person + " did not have the " + item + ".";
  }
  if (clue.type === "roomItem") {
    return clue.yes
      ? "The person in the " + room.toLowerCase() + " had the " + item + "."
      : "The person in the " + room.toLowerCase() + " did not have the " + item + ".";
  }
  if (clue.type === "guiltyRoom") {
    return clue.yes
      ? "The guilty person was in the " + room.toLowerCase() + "."
      : "The guilty person was not in the " + room.toLowerCase() + ".";
  }
  if (clue.type === "guiltyItem") {
    return clue.yes
      ? "The guilty person had the " + item + "."
      : "The guilty person did not have the " + item + ".";
  }
  throw new Error("Unknown clue");
}

function trueClues(solution) {
  const clues = [];
  for (let person = 0; person < 4; person++) {
    for (let room = 0; room < 4; room++) {
      const yes = solution.rooms[person] === room;
      clues.push({ type: "personRoom", person: person, room: room, item: -1, yes: yes });
    }
    for (let item = 0; item < 4; item++) {
      const yes = solution.items[person] === item;
      clues.push({ type: "personItem", person: person, item: item, room: -1, yes: yes });
    }
  }
  for (let room = 0; room < 4; room++) {
    for (let item = 0; item < 4; item++) {
      let person = 0;
      while (solution.rooms[person] !== room) person++;
      const yes = solution.items[person] === item;
      clues.push({ type: "roomItem", room: room, item: item, person: -1, yes: yes });
    }
    clues.push({
      type: "guiltyRoom",
      room: room,
      person: -1,
      item: -1,
      yes: solution.rooms[solution.guilty] === room,
    });
  }
  for (let item = 0; item < 4; item++) {
    clues.push({
      type: "guiltyItem",
      item: item,
      person: -1,
      room: -1,
      yes: solution.items[solution.guilty] === item,
    });
  }
  return clues;
}

function guiltyCount(clues) {
  let count = 0;
  for (let i = 0; i < clues.length; i++) if (clues[i].type.indexOf("guilty") === 0) count++;
  return count;
}

function clueRank(clue) {
  if (clue.type === "roomItem") return 3;
  if (!clue.yes) return 2;
  return 1;
}

function countAlone(clue) {
  let left = 0;
  for (let i = 0; i < WORLDS.length; i++) if (holds(WORLDS[i], clue)) left++;
  return left;
}

function buildClues(solution) {
  const pool = trueClues(solution).filter(function (clue) {
    const left = countAlone(clue);
    return left >= 48 && left < WORLDS.length;
  });
  const chosen = [];
  let current = WORLDS;
  while (current.length > 1 && chosen.length < 24) {
    let best = null;
    let bestScore = -1;
    let bestLeft = current.length;
    function consider(allowGuilty) {
      for (let i = 0; i < pool.length; i++) {
        const clue = pool[i];
        if (chosen.indexOf(clue) >= 0) continue;
        const isGuilty = clue.type.indexOf("guilty") === 0;
        if (isGuilty && !allowGuilty) continue;
        let left = 0;
        for (let w = 0; w < current.length; w++) if (holds(current[w], clue)) left++;
        if (left < 1 || left >= current.length) continue;
        const score = left === 1 ? 0 : Math.min(left, current.length - left);
        const rank = clueRank(clue);
        const bestRank = best ? clueRank(best) : -1;
        const betterScore = score > bestScore;
        const sameScore = score === bestScore && (rank > bestRank || (rank === bestRank && left < bestLeft));
        if (betterScore || sameScore) {
          best = clue;
          bestScore = score;
          bestLeft = left;
        }
      }
    }
    consider(guiltyCount(chosen) < 2);
    if (!best) consider(true);
    if (!best) throw new Error("Could not finish the notes, " + current.length + " grids left");
    chosen.push(best);
    const next = [];
    for (let w = 0; w < current.length; w++) if (holds(current[w], best)) next.push(current[w]);
    current = next;
  }
  let pruned = chosen.slice();
  let changed = true;
  while (changed) {
    changed = false;
    for (let i = 0; i < pruned.length; i++) {
      const trial = pruned.filter(function (_, j) { return j !== i; });
      if (survivors(trial).length === 1) {
        pruned = trial;
        changed = true;
        break;
      }
    }
  }
  const left = survivors(pruned);
  if (left.length !== 1 || !sameWorld(left[0], solution)) throw new Error("Notes are not unique");
  return pruned;
}

function caseLabel(seed) {
  return (seed >>> 0).toString(16).padStart(8, "0");
}

function fullName(person) {
  return person[0] + " " + person[1];
}

function introParagraphs() {
  return [
    "The house was locked at ten. Four people were still inside. Each one was in a different room. Each one had a different thing in hand. By morning, one of them was guilty.",
    "Every note is true. No note names the guilty person, the guilty room, and the thing together. Mark the grid until one person, one room, and one thing fit all of it.",
  ];
}

function createCase(seed) {
  const rng = mulberry32(seed);
  const firsts = shuffle(rng, FIRST).slice(0, 4);
  const lasts = shuffle(rng, LAST).slice(0, 4);
  const people = firsts.map(function (name, i) { return [name, lasts[i]]; });
  const rooms = shuffle(rng, ROOMS).slice(0, 4);
  const items = shuffle(rng, ITEMS).slice(0, 4);
  const solution = {
    rooms: shuffle(rng, [0, 1, 2, 3]),
    items: shuffle(rng, [0, 1, 2, 3]),
    guilty: Math.floor(rng() * 4),
  };
  const clues = shuffle(rng, buildClues(solution)).map(function (clue) {
    return {
      type: clue.type,
      person: clue.person,
      room: clue.room,
      item: clue.item,
      yes: clue.yes,
      text: clueText(clue, people, rooms, items),
    };
  });
  return {
    version: 1,
    seed: seed >>> 0,
    people: people,
    rooms: rooms,
    items: items,
    roomsOf: solution.rooms.slice(),
    itemsOf: solution.items.slice(),
    guilty: solution.guilty,
    clues: clues,
  };
}

function worldFromCase(state) {
  return { rooms: state.roomsOf, items: state.itemsOf, guilty: state.guilty };
}

function assertCase(state) {
  if (!state || state.version !== 1) throw new Error("Bad case");
  if (!state.people || state.people.length !== 4) throw new Error("Bad people");
  if (!state.rooms || state.rooms.length !== 4 || !state.items || state.items.length !== 4) throw new Error("Bad lists");
  if (!state.clues || state.clues.length < 2) throw new Error("Too few notes");
  const solution = worldFromCase(state);
  for (let i = 0; i < state.clues.length; i++) {
    if (!holds(solution, state.clues[i])) throw new Error("A note is false");
    if (state.clues[i].type === "guiltyPerson") throw new Error("A note names the guilty person");
  }
  const left = survivors(state.clues);
  if (left.length !== 1 || !sameWorld(left[0], solution)) throw new Error("Notes are not unique");
  for (let i = 0; i < state.clues.length; i++) {
    const trial = state.clues.filter(function (_, j) { return j !== i; });
    if (survivors(trial).length < 2) throw new Error("A note is not needed");
  }
  const guiltyName = fullName(state.people[state.guilty]);
  const blob = state.clues.map(function (clue) { return clue.text; }).join(" ");
  if (blob.indexOf(guiltyName + " is guilty") >= 0) throw new Error("The notes name the guilty person");
}

function trioPhrase(state) {
  const person = fullName(state.people[state.guilty]);
  const room = state.rooms[state.roomsOf[state.guilty]];
  const item = state.items[state.itemsOf[state.guilty]];
  return person + ", in the " + room.toLowerCase() + ", with the " + item + ".";
}

function runSelfTest() {
  const seen = {};
  for (let seed = 1; seed <= 12; seed++) {
    const made = createCase(seed);
    assertCase(made);
    const again = createCase(seed);
    if (JSON.stringify(made) !== JSON.stringify(again)) throw new Error("Seed " + seed + " moved");
    seen[made.clues.length] = (seen[made.clues.length] || 0) + 1;
    if (/murder|cluedo|murdle|logico|library|billiard|conservatory|alice|starling/i.test(JSON.stringify(made))) {
      throw new Error("Reserved wording in seed " + seed);
    }
  }
  const summary = "quiet house cases 12 clue counts " + JSON.stringify(seen);
  if (typeof print === "function") print(summary);
  else console.log(summary);
}

if (typeof window === "undefined") runSelfTest();

globalThis.QuietHouse = {
  TITLE: TITLE,
  DEK: DEK,
  introParagraphs: introParagraphs,
  caseLabel: caseLabel,
  fullName: fullName,
  createCase: createCase,
  assertCase: assertCase,
  trioPhrase: trioPhrase,
  holds: holds,
  survivors: survivors,
};
